module.exports = __webpack_public_path__ + "static/media/en.650d551a.svg";